import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ObjektArtsQuerySorterConfig } from 'fa-kt.types';
import { ObjektArtsService } from '../service';

@Component({
  selector: 'fa-kt-objekt-arts-sorter',
  templateUrl: './objekt-arts-sorter.component.html',
  styleUrls: ['./objekt-arts-sorter.component.css'],
})
export class ObjektArtsSorterComponent {
  ObjektArtsSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public objektArts: ObjektArtsService,
  ) {
    this.ObjektArtsSorterConfig = ObjektArtsQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
